<template lang="html">
  <d-form @submit.prevent="save" :validated="hasErrors">
    <d-form-row>

      <!-- Nome -->
      <d-col md="9" class="form-group">
        <label for="name">Nome</label>
        <d-form-input
          :state="hasErrorFiled('name')"
          type="text"
          id="name"
          placeholder="Nome"
          v-model="model.name"
        />
        <d-form-invalid-feedback>Nome é obrigatório</d-form-invalid-feedback>
      </d-col>


      <!-- Price -->
      <d-col md="3" class="form-group">
        <label for="fePrice">Preço</label>
        <d-input-group prepend="R$">
          <input-currency
            model-index="price"
            placeholder="Total"
            :model="model"
          ></input-currency>
        </d-input-group>
      </d-col>

    </d-form-row>

  </d-form>
</template>

<script>
import { mapActions } from 'vuex';
import InputCurrency from '_shared/InputCurrency.vue';
import Loader from '_shared/Loader.vue';
import ServiceService from '_services/rest/modules/service';
import Events from '_utils/events';
import mixin from '_common/mixins/ValidateForm';
import { MODEL, _LOAD_MODEL_, _SAVE_SERVICE_SUCCESS_ } from './ServiceModel';

export default {
  name: 'service-form',
  mixins: [mixin],
  components: {
    InputCurrency,
    Loader,
  },
  data() {
    return {
      model: { ...MODEL },
      loading: false,
      errors: {
        name: { required: false },
        price: { required: false },
      },
    };
  },
  methods: {
    ...mapActions([
      'setToggle',
      'activeAlert',
      'getProductUnits',
    ]),

    save() {
      if (this.checkForm()) {
        ServiceService.save(this.model)
          .then(response => {
            this.success(response);
          })
          .catch(error => {
            this.activeAlert({ message: `${error.message} <br/> ${error.data}`, theme: 'danger' });
          });
      }
      return null;
    },
    success(serviceSaved) {
      this.activeAlert({ message: 'Serviço salvo com sucesso', theme: 'success' });
      this.$store.commit('setService', serviceSaved);
      Events.$emit(_SAVE_SERVICE_SUCCESS_, serviceSaved);
    },
  },
  mounted() {
    Events.$on(_LOAD_MODEL_, newValue => {
      this.model = { ...newValue };
    });
    this.getOptions();
  },
};
</script>

<style lang="scss" scoped>
</style>
